var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37431 26.9815C6.97294 26.9815 4.83693 25.4439 4.06122 23.1548L4.00877 22.9823C3.82581 22.3761 3.74917 21.8664 3.74917 21.3563V11.1289L0.11012 23.2762C-0.357892 25.0629 0.708636 26.9153 2.49806 27.4088L25.6933 33.6207C25.9755 33.6941 26.2658 33.7314 26.5574 33.7316C28.0513 33.7316 29.4163 32.7401 29.799 31.2789L31.1504 26.9815H9.37431ZM13.4995 11.2311C15.1541 11.2311 16.4994 9.88545 16.4994 8.23088C16.4994 6.57632 15.1541 5.23071 13.4995 5.23071C11.8449 5.23071 10.4993 6.57639 10.4993 8.23088C10.4993 9.88538 11.8449 11.2311 13.4995 11.2311Z",
    fill: "#ADDE34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2496 0.730591H9.74902C7.68221 0.730591 5.99902 2.41377 5.99902 4.48087V20.9811C5.99902 23.0483 7.68221 24.7314 9.74902 24.7314H32.2496C34.3168 24.7314 35.9999 23.0483 35.9999 20.9811V4.48087C35.9999 2.41377 34.3168 0.730591 32.2496 0.730591ZM9.74902 3.73076H32.2496C32.6638 3.73076 32.9997 4.06672 32.9997 4.48087V15.1296L28.2612 9.60039C27.7586 9.01094 27.031 8.69586 26.2495 8.67807C25.4726 8.68243 24.7435 9.0274 24.2456 9.62451L18.6743 16.3115L16.8593 14.5009C15.8334 13.4751 14.1638 13.4751 13.1392 14.5009L8.99919 18.6396V4.4808C8.99919 4.06665 9.33515 3.73076 9.74902 3.73076Z",
    fill: "#317153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteimg);
export default __webpack_public_path__ + "static/media/siteimg.3240297f555189c1ead1f2f2cb43dc0d.svg";
export { ForwardRef as ReactComponent };